import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Mug = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.689 6.98001V11.86C12.689 13.4133 11.429 14.6667 9.88235 14.6667H4.96902C3.42235 14.6667 2.16235 13.4067 2.16235 11.86V6.98001C2.16235 5.42667 3.42235 4.17334 4.96902 4.17334H9.88235C11.429 4.17334 12.689 5.43334 12.689 6.98001Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.49585 2.66667V1.5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.16235 2.66667V1.5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.8291 2.66667V1.5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4959 8.77334C15.4959 10.32 14.2359 11.58 12.6892 11.58V5.96667C14.2359 5.96667 15.4959 7.22001 15.4959 8.77334Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16235 8H12.5024"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Mug.displayName = 'Mug';
